var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconmetroCalendar1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.25,
    height: 34.647,
    viewBox: "0 0 35.25 34.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 0.898,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#338fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43c6fe"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_metro-calendar",
    x: 0,
    y: 0,
    width: 35.25,
    height: 34.647,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_metro-calendar)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-calendar-2",
    "data-name": "Icon metro-calendar",
    d: "M8.321,8.171h2.3v2.081h-2.3Zm3.45,0h2.3v2.081h-2.3Zm3.45,0h2.3v2.081h-2.3ZM4.871,14.413h2.3v2.081h-2.3Zm3.45,0h2.3v2.081h-2.3Zm3.45,0h2.3v2.081h-2.3Zm-3.45-3.121h2.3v2.081h-2.3Zm3.45,0h2.3v2.081h-2.3Zm3.45,0h2.3v2.081h-2.3Zm-10.35,0h2.3v2.081h-2.3Zm12.65-9.364v1.04h-2.3V1.928H7.171v1.04h-2.3V1.928h-2.3V18.575h17.25V1.928h-2.3Zm1.15,15.607H3.721V6.09h14.95Z",
    transform: "translate(6.43 4.07)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmetroCalendar1);
export default __webpack_public_path__ + "static/media/Icon metro-calendar (1).efefbdb3d8dbd1709a2f66687d08ae87.svg";
export { ForwardRef as ReactComponent };